import React from 'react'
import classnames from 'classnames'

export function cloneElementWithClassName(child: React.ReactElement<any>, className: string) {
  return React.cloneElement(child, {
    className: classnames(child.props.className, className)
  })
}
